<template>
    <div class="login-modal-content">
      <v-card width="500" class="mx-auto mt-5">
        <div style="text-align:center;padding-top:10px;">
          <h3>Sign in</h3>
        </div>
        <v-card-text>
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-form ref="form">
            <div style="padding-bottom:20px">
              <vue-phone-number-input 
                v-model="phone_number" 
                label="Phone number"
                default-country-code="ZM"
                required
                @update="getPhoneNumber"
                no-example
              />
            </div>
            <div>
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-model="password"
                outlined
                required
                :rules="[v => !!v || 'Password is a required field']"       
                dense
              />
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <div style="text-align:center;padding:10px">
          <v-btn
            :loading="loading"
            color="primary"
            rounded
            dark
            block
            @click="submit"
          >
            Sign in
          </v-btn>
        </div>        
      </v-card>  
      <div style="text-align:center">
        <br />
        <p>
          Don't have an Account? 
          <router-link to="/register">
            Register here
          </router-link>
        </p>
        <p> 
          <router-link to="/forgot_password">
            Forgot your password?
          </router-link>
        </p>
      </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  import axios from "axios";

  const URL = "http://139.59.131.242:4000/user/login";
  
  export default {
    name: 'Login',
    data: () => ({
      phone_number: '',
      showPassword: false,
      password: '',
      loading: false,
      error: null,
      data: null
    }),
    methods: {
      submit() {
        
        if (this.$refs.form.validate()){
          this.loading = true;

          const user = {
            phone_number: this.user.data.phone_number,
            password: this.password,
          }

          axios
          .get(URL, { params:user })
          .then(response => {
            if (response.data.status == 'success'){
              this.$store.dispatch("fetchUser", response.data.user);
              this.loading = false;
              this.$router.push('/dashboard');
            }
          })
          .catch(error => {
            console.log(error);
            this.error = 'Invalid phone number and/or password!';
            this.loading = false;
          }); 
        }
      },
      getPhoneNumber(payload){
        this.user.data.phone_number = payload.formattedNumber;
      }
    },
    computed: {
      ...mapGetters({
        user: "user"
      })
    }
  }
</script>